var _path, _path2, _path3, _path4, _path5, _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecentralize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5009 47.8242C58.9056 47.8242 65.7189 41.0109 65.7189 32.6062C65.7189 24.2015 58.9056 17.3882 50.5009 17.3882C42.0963 17.3882 35.2829 24.2015 35.2829 32.6062C35.2829 41.0109 42.0963 47.8242 50.5009 47.8242Z",
    fill: "url(#paint0_linear_16_176)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5009 69.5627C55.3036 69.5627 59.197 65.6693 59.197 60.8667C59.197 56.064 55.3036 52.1707 50.5009 52.1707C45.6983 52.1707 41.8049 56.064 41.8049 60.8667C41.8049 65.6693 45.6983 69.5627 50.5009 69.5627Z",
    fill: "url(#paint1_linear_16_176)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5009 99.9994C55.3036 99.9994 59.197 96.1061 59.197 91.3034C59.197 86.5008 55.3036 82.6074 50.5009 82.6074C45.6983 82.6074 41.8049 86.5008 41.8049 91.3034C41.8049 96.1061 45.6983 99.9994 50.5009 99.9994Z",
    fill: "url(#paint2_linear_16_176)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5869 93.4772C31.3896 93.4772 35.2829 89.5839 35.2829 84.7812C35.2829 79.9785 31.3896 76.0852 26.5869 76.0852C21.7843 76.0852 17.8909 79.9785 17.8909 84.7812C17.8909 89.5839 21.7843 93.4772 26.5869 93.4772Z",
    fill: "url(#paint3_linear_16_176)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.415 93.4772C79.2176 93.4772 83.111 89.5839 83.111 84.7812C83.111 79.9785 79.2176 76.0852 74.415 76.0852C69.6123 76.0852 65.719 79.9785 65.719 84.7812C65.719 89.5839 69.6123 93.4772 74.415 93.4772Z",
    fill: "url(#paint4_linear_16_176)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bi_16_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.8062 56.52C71.3744 56.5199 70.9524 56.3913 70.5941 56.1505C70.2357 55.9097 69.9571 55.5677 69.7939 55.1679C69.6306 54.7682 69.5901 54.329 69.6774 53.9061C69.7648 53.4833 69.9761 53.096 70.2844 52.7937C74.2934 48.8641 77.0413 43.8296 78.1778 38.332C79.3142 32.8345 78.7877 27.1231 76.6654 21.9259C74.5431 16.7288 70.9211 12.2815 66.2612 9.15096C61.6013 6.02046 56.1147 4.34862 50.501 4.34862C44.8872 4.34862 39.4006 6.02046 34.7407 9.15096C30.0809 12.2815 26.4588 16.7288 24.3365 21.9259C22.2142 27.1231 21.6877 32.8345 22.8241 38.332C23.9606 43.8296 26.7085 48.8641 30.7175 52.7937C30.9261 52.9925 31.0931 53.2307 31.2089 53.4945C31.3246 53.7584 31.3867 54.0426 31.3916 54.3307C31.3965 54.6187 31.3441 54.9049 31.2375 55.1725C31.1308 55.4402 30.972 55.6839 30.7703 55.8897C30.5686 56.0954 30.328 56.259 30.0626 56.3709C29.7971 56.4829 29.512 56.5409 29.2239 56.5417C28.9358 56.5425 28.6504 56.486 28.3843 56.3756C28.1182 56.2651 27.8768 56.1028 27.6739 55.8982C23.0481 51.364 19.8774 45.5549 18.5661 39.2116C17.2549 32.8683 17.8624 26.2782 20.3112 20.2815C22.7601 14.2848 26.9393 9.15328 32.3161 5.54116C37.6928 1.92904 44.0235 0 50.501 0C56.9784 0 63.3091 1.92904 68.6858 5.54116C74.0626 9.15328 78.2419 14.2848 80.6907 20.2815C83.1396 26.2782 83.7471 32.8683 82.4358 39.2116C81.1245 45.5549 77.9538 51.364 73.328 55.8982C72.9216 56.2967 72.3753 56.5199 71.8062 56.52Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8062 56.52C71.3744 56.5199 70.9524 56.3913 70.5941 56.1505C70.2357 55.9097 69.9571 55.5677 69.7939 55.1679C69.6306 54.7682 69.5901 54.329 69.6774 53.9061C69.7648 53.4833 69.9761 53.096 70.2844 52.7937C74.2934 48.8641 77.0413 43.8296 78.1778 38.332C79.3142 32.8345 78.7877 27.1231 76.6654 21.9259C74.5431 16.7288 70.9211 12.2815 66.2612 9.15096C61.6013 6.02046 56.1147 4.34862 50.501 4.34862C44.8872 4.34862 39.4006 6.02046 34.7407 9.15096C30.0809 12.2815 26.4588 16.7288 24.3365 21.9259C22.2142 27.1231 21.6877 32.8345 22.8241 38.332C23.9606 43.8296 26.7085 48.8641 30.7175 52.7937C30.9261 52.9925 31.0931 53.2307 31.2089 53.4945C31.3246 53.7584 31.3867 54.0426 31.3916 54.3307C31.3965 54.6187 31.3441 54.9049 31.2375 55.1725C31.1308 55.4402 30.972 55.6839 30.7703 55.8897C30.5686 56.0954 30.328 56.259 30.0626 56.3709C29.7971 56.4829 29.512 56.5409 29.2239 56.5417C28.9358 56.5425 28.6504 56.486 28.3843 56.3756C28.1182 56.2651 27.8768 56.1028 27.6739 55.8982C23.0481 51.364 19.8774 45.5549 18.5661 39.2116C17.2549 32.8683 17.8624 26.2782 20.3112 20.2815C22.7601 14.2848 26.9393 9.15328 32.3161 5.54116C37.6928 1.92904 44.0235 0 50.501 0C56.9784 0 63.3091 1.92904 68.6858 5.54116C74.0626 9.15328 78.2419 14.2848 80.6907 20.2815C83.1396 26.2782 83.7471 32.8683 82.4358 39.2116C81.1245 45.5549 77.9538 51.364 73.328 55.8982C72.9216 56.2967 72.3753 56.5199 71.8062 56.52Z",
    fill: "url(#paint5_linear_16_176)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8749 53.6657L29.8688 53.6596C25.6878 49.5614 22.8219 44.3109 21.6367 38.5775C20.4515 32.8441 21.0006 26.8876 23.214 21.4675C25.4274 16.0474 29.2048 11.4093 34.0646 8.14449C38.9244 4.87968 44.6463 3.13612 50.501 3.13612C56.3556 3.13612 62.0775 4.87968 66.9373 8.14449C71.7971 11.4093 75.5745 16.0474 77.7879 21.4675C80.0013 26.8876 80.5504 32.8441 79.3652 38.5775C78.18 44.3108 75.3142 49.5613 71.1333 53.6595C70.9969 53.7932 70.9035 53.9644 70.8649 54.1514C70.8262 54.3385 70.8442 54.5327 70.9163 54.7095C70.9885 54.8863 71.1117 55.0376 71.2703 55.1441C71.4287 55.2505 71.6152 55.3074 71.806 55.3075L29.8749 53.6657ZM29.8749 53.6657L29.8812 53.6716M29.8749 53.6657L29.8812 53.6716M29.8812 53.6716C29.9734 53.7595 30.0473 53.8648 30.0985 53.9815C30.1496 54.0982 30.1771 54.2239 30.1793 54.3513C30.1815 54.4787 30.1583 54.6053 30.1111 54.7237C30.0639 54.842 29.9937 54.9499 29.9045 55.0408C29.8153 55.1318 29.7089 55.2042 29.5915 55.2537C29.4741 55.3032 29.348 55.3289 29.2206 55.3292C29.0932 55.3296 28.9669 55.3046 28.8492 55.2557C28.7316 55.2069 28.6248 55.1351 28.5351 55.0446L28.5289 55.0384M29.8812 53.6716L28.5289 55.0384M28.5289 55.0384L28.5227 55.0323M28.5289 55.0384L28.5227 55.0323M28.5227 55.0323C24.0689 50.6667 21.0161 45.0736 19.7535 38.9662C18.491 32.8587 19.0759 26.5136 21.4337 20.7399C23.7915 14.9662 27.8154 10.0254 32.9922 6.54763C38.1691 3.06981 44.2644 1.2125 50.501 1.2125C56.7375 1.2125 62.8328 3.06981 68.0097 6.54763C73.1865 10.0254 77.2104 14.9662 79.5682 20.7399C81.926 26.5136 82.5109 32.8587 81.2484 38.9662C79.9858 45.0736 76.933 50.6667 72.4792 55.0323L72.479 55.0325M28.5227 55.0323L72.479 55.0325M72.479 55.0325C72.2994 55.2086 72.0579 55.3074 71.8063 55.3075L72.479 55.0325Z",
    stroke: "url(#paint6_linear_16_176)",
    strokeOpacity: 0.1,
    strokeWidth: 2.425
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bi_16_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.501 86.9553C49.9244 86.9553 49.3714 86.7263 48.9637 86.3186C48.556 85.9109 48.327 85.3579 48.327 84.7813V67.3893C48.327 66.8128 48.556 66.2598 48.9637 65.8521C49.3714 65.4444 49.9244 65.2153 50.501 65.2153C51.0775 65.2153 51.6305 65.4444 52.0382 65.8521C52.4459 66.2598 52.675 66.8128 52.675 67.3893V84.7813C52.675 85.3579 52.4459 85.9109 52.0382 86.3186C51.6305 86.7263 51.0775 86.9553 50.501 86.9553Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.501 86.9553C49.9244 86.9553 49.3714 86.7263 48.9637 86.3186C48.556 85.9109 48.327 85.3579 48.327 84.7813V67.3893C48.327 66.8128 48.556 66.2598 48.9637 65.8521C49.3714 65.4444 49.9244 65.2153 50.501 65.2153C51.0775 65.2153 51.6305 65.4444 52.0382 65.8521C52.4459 66.2598 52.675 66.8128 52.675 67.3893V84.7813C52.675 85.3579 52.4459 85.9109 52.0382 86.3186C51.6305 86.7263 51.0775 86.9553 50.501 86.9553Z",
    fill: "url(#paint7_linear_16_176)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.501 85.7428C50.2459 85.7428 50.0014 85.6415 49.8211 85.4612C49.6408 85.2809 49.5395 85.0363 49.5395 84.7813V67.3893C49.5395 67.1343 49.6408 66.8898 49.8211 66.7094C50.0014 66.5291 50.2459 66.4278 50.501 66.4278C50.756 66.4278 51.0005 66.5291 51.1808 66.7094C51.3612 66.8898 51.4625 67.1343 51.4625 67.3893V84.7813C51.4625 85.0363 51.3612 85.2809 51.1808 85.4612C51.0005 85.6415 50.756 85.7428 50.501 85.7428Z",
    stroke: "url(#paint8_linear_16_176)",
    strokeOpacity: 0.1,
    strokeWidth: 2.425
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bi_16_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.587 80.4349C26.0104 80.4349 25.4574 80.2058 25.0497 79.7981C24.642 79.3904 24.413 78.8375 24.413 78.2609V69.5649C24.4108 69.159 24.5222 68.7607 24.7347 68.4149C24.9471 68.0691 25.2521 67.7897 25.6152 67.6083L43.0072 58.9123C43.5232 58.6546 44.1205 58.6124 44.6677 58.795C45.2148 58.9777 45.667 59.3702 45.9247 59.8862C46.1824 60.4023 46.2246 60.9996 46.042 61.5467C45.8593 62.0938 45.4668 62.546 44.9508 62.8037L28.761 70.9084V78.2609C28.761 78.8375 28.5319 79.3904 28.1242 79.7981C27.7165 80.2058 27.1636 80.4349 26.587 80.4349Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.587 80.4349C26.0104 80.4349 25.4574 80.2058 25.0497 79.7981C24.642 79.3904 24.413 78.8375 24.413 78.2609V69.5649C24.4108 69.159 24.5222 68.7607 24.7347 68.4149C24.9471 68.0691 25.2521 67.7897 25.6152 67.6083L43.0072 58.9123C43.5232 58.6546 44.1205 58.6124 44.6677 58.795C45.2148 58.9777 45.667 59.3702 45.9247 59.8862C46.1824 60.4023 46.2246 60.9996 46.042 61.5467C45.8593 62.0938 45.4668 62.546 44.9508 62.8037L28.761 70.9084V78.2609C28.761 78.8375 28.5319 79.3904 28.1242 79.7981C27.7165 80.2058 27.1636 80.4349 26.587 80.4349Z",
    fill: "url(#paint9_linear_16_176)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6255 69.5649H25.6255L25.6255 69.5583C25.6245 69.3788 25.6738 69.2026 25.7677 69.0497C25.8617 68.8967 25.9966 68.7731 26.1572 68.6929L26.1574 68.6928L43.549 59.997C43.549 59.997 43.5491 59.997 43.5491 59.9969C43.5492 59.9969 43.5493 59.9968 43.5494 59.9968C43.7777 59.8829 44.0418 59.8644 44.2837 59.9451C44.5258 60.026 44.7259 60.1996 44.84 60.428C44.954 60.6563 44.9727 60.9206 44.8919 61.1628C44.811 61.4049 44.6373 61.605 44.409 61.719L44.408 61.7195L28.2182 69.8242L27.5485 70.1595V70.9084V78.2609C27.5485 78.5159 27.4472 78.7605 27.2669 78.9408C27.0865 79.1211 26.842 79.2224 26.587 79.2224C26.332 79.2224 26.0874 79.1211 25.9071 78.9408C25.7268 78.7605 25.6255 78.5159 25.6255 78.2609V69.5649Z",
    stroke: "url(#paint10_linear_16_176)",
    strokeOpacity: 0.1,
    strokeWidth: 2.425
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bi_16_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.4159 80.4349C73.8393 80.4349 73.2863 80.2058 72.8786 79.7981C72.4709 79.3904 72.2419 78.8375 72.2419 78.2609V70.9084L56.0521 62.8255C55.536 62.5677 55.1435 62.1156 54.9609 61.5684C54.7782 61.0213 54.8204 60.424 55.0781 59.908C55.3359 59.3919 55.788 58.9994 56.3352 58.8168C56.8823 58.6341 57.4796 58.6763 57.9956 58.934L75.3877 67.63C75.7474 67.8098 76.0502 68.0858 76.2625 68.4274C76.4747 68.769 76.5881 69.1627 76.5899 69.5649V78.2609C76.5899 78.8375 76.3608 79.3904 75.9531 79.7981C75.5454 80.2058 74.9925 80.4349 74.4159 80.4349Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4159 80.4349C73.8393 80.4349 73.2863 80.2058 72.8786 79.7981C72.4709 79.3904 72.2419 78.8375 72.2419 78.2609V70.9084L56.0521 62.8255C55.536 62.5677 55.1435 62.1156 54.9609 61.5684C54.7782 61.0213 54.8204 60.424 55.0781 59.908C55.3359 59.3919 55.788 58.9994 56.3352 58.8168C56.8823 58.6341 57.4796 58.6763 57.9956 58.934L75.3877 67.63C75.7474 67.8098 76.0502 68.0858 76.2625 68.4274C76.4747 68.769 76.5881 69.1627 76.5899 69.5649V78.2609C76.5899 78.8375 76.3608 79.3904 75.9531 79.7981C75.5454 80.2058 74.9925 80.4349 74.4159 80.4349Z",
    fill: "url(#paint11_linear_16_176)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4544 70.9084V70.1585L72.7835 69.8236L56.5939 61.7407C56.5938 61.7407 56.5937 61.7407 56.5937 61.7407C56.3654 61.6266 56.1918 61.4265 56.111 61.1845C56.0302 60.9424 56.0488 60.6781 56.1629 60.4497C56.2769 60.2214 56.477 60.0477 56.7191 59.9669C56.9611 59.8861 57.2252 59.9047 57.4534 60.0185C57.4535 60.0186 57.4536 60.0186 57.4537 60.0187C57.4538 60.0187 57.4538 60.0187 57.4539 60.0187L74.8454 68.7145L74.8457 68.7146C75.0048 68.7942 75.1387 68.9162 75.2326 69.0673C75.326 69.2177 75.3761 69.391 75.3774 69.5681V78.2609C75.3774 78.5159 75.2761 78.7605 75.0958 78.9408C74.9154 79.1211 74.6709 79.2224 74.4159 79.2224C74.1609 79.2224 73.9163 79.1211 73.736 78.9408C73.5557 78.7605 73.4544 78.5159 73.4544 78.2609V70.9084Z",
    stroke: "url(#paint12_linear_16_176)",
    strokeOpacity: 0.1,
    strokeWidth: 2.425
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_16_176",
    x: -30.6091,
    y: -48.5,
    width: 162.22,
    height: 153.542,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 24.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_16_176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_16_176",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.08333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_16_176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bi_16_176",
    x: -0.173046,
    y: 16.7153,
    width: 101.348,
    height: 118.74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 24.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_16_176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_16_176",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.08333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_16_176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bi_16_176",
    x: -24.0871,
    y: 10.1831,
    width: 118.741,
    height: 118.752,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 24.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_16_176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_16_176",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.08333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_16_176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bi_16_176",
    x: 6.34896,
    y: 10.2048,
    width: 118.741,
    height: 118.73,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 24.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_16_176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_16_176",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.08333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_16_176"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_176",
    x1: 35.2829,
    y1: 17.3882,
    x2: 71.1356,
    y2: 26.4918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16_176",
    x1: 41.8049,
    y1: 52.1707,
    x2: 62.2922,
    y2: 57.3727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16_176",
    x1: 41.8049,
    y1: 82.6074,
    x2: 62.2922,
    y2: 87.8095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16_176",
    x1: 17.8909,
    y1: 76.0852,
    x2: 38.3782,
    y2: 81.2873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_16_176",
    x1: 65.719,
    y1: 76.0852,
    x2: 86.2062,
    y2: 81.2873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_16_176",
    x1: 17.8909,
    y1: 0,
    x2: 93.2103,
    y2: 22.0604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_16_176",
    x1: 19.9291,
    y1: 2.57008,
    x2: 83.111,
    y2: 2.57008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_16_176",
    x1: 48.327,
    y1: 65.2153,
    x2: 53.765,
    y2: 65.4915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_16_176",
    x1: 48.4628,
    y1: 66.2035,
    x2: 52.675,
    y2: 66.2035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_16_176",
    x1: 24.4129,
    y1: 58.6831,
    x2: 50.0247,
    y2: 65.1832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_16_176",
    x1: 25.0923,
    y1: 59.6718,
    x2: 46.1539,
    y2: 59.6718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_16_176",
    x1: 54.849,
    y1: 58.7048,
    x2: 80.4575,
    y2: 65.2106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_16_176",
    x1: 55.5284,
    y1: 59.6926,
    x2: 76.5899,
    y2: 59.6926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecentralize);
export default __webpack_public_path__ + "static/media/decentralize.2f661d04a7232421f6c47922d9e15602.svg";
export { ForwardRef as ReactComponent };